import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  inject,
} from '@angular/core';
import { Editor, defaultValueCtx, rootCtx } from '@milkdown/core';
import { commonmark } from '@milkdown/preset-commonmark';
import { nord } from '@milkdown/theme-nord';
import { getMarkdown } from '@milkdown/utils';
import { Subject } from 'rxjs';
import { HtmlToMarkdownService } from 'src/core/services';
// import Quill from "quill";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// import QuillMarkdown from 'quilljs-markdown';

@Component({
  selector: 'core-wysiwyg-editor',
  templateUrl: './wysiwyg-editor.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WysiwygEditorComponent implements AfterViewInit, OnDestroy {
  private htmlToMarkdownService = inject(HtmlToMarkdownService);

  @Input() editorContent!: string | null;
  @ViewChild('editorRef') editorRef!: ElementRef;
  private destroy$ = new Subject<void>();
  private editor!: Editor;

  // ngAfterViewInit() {
  //   Quill.register('modules/markdown', QuillMarkdown, true);
  //   this.editor = new Quill('#editor', {
  //     theme: 'snow',
  //     modules: {
  //       markdown: true,
  //       toolbar: [
  //         ['bold', 'italic', 'underline', 'strike'],
  //         ['blockquote', 'code-block'],
  //         [{list: 'ordered'}, {list: 'bullet'}],
  //         [{header: [1, 2, 3, 4, 5, 6, false]}],
  //         [{color: []}, {background: []}],
  //         ['link', 'image'],
  //       ],
  //     },
  //   });
  // }

  ngAfterViewInit() {
    this.createEditor()
      .then((data) => {
        this.editor = data;
      })
      .catch((error) => {
        console.error(
          'WYSIWYG editor could not be created: ',
          error.error?.message,
        );
      });
  }

  async createEditor() {
    return await Editor.make()
      .config((ctx) => {
        ctx.set(rootCtx, this.editorRef?.nativeElement);
        ctx.set(defaultValueCtx, this.editorContent ? this.editorContent : '');
      })
      .config(nord)
      .use(commonmark)
      .create();
  }

  getEditorContent() {
    // return this.htmlToMarkdownService.convert(this.editor.getSemanticHTML());
    return this.editor.action(getMarkdown());
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
